<div class="blog-container">
    <div class="header-container">
        <app-header [theme]="'transparent'"></app-header>
        <div>
            <p class="first-p">{{'NEWS'|translate}}</p>
            <p class="second-p"> {{'news-text-one'|translate}} </p>
            <p class="second-p"> {{'news-text-two'|translate}} </p>
            <div class="search-container">
                <input type="text" class="search-box" placeholder="Search...." (keyup)="search($event)">
                <span class="search-icon-container"> <i class="fa fa-search" aria-hidden="true"></i> </span>
            </div>
        </div>
    </div>
    <div class="all-blog-items-container">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-12" *ngFor="let news of AllNews | paginate: { itemsPerPage: 6, currentPage: p }">
            <div class="blog-element">
              <div class="blog-img-container">
                <img [src]="news.image_url">
              </div>
              <div class="m-4">
                  <p class="blog-title"> {{news.title}} </p>
                  <p class="blog-date"> {{news.date}} </p>
                  <p class="blog-clamped">
                      {{news.summary}}
                      <span>....</span>
                  </p>
                  <a class="blog-readMore" routerLink="/news/{{news.name}}"> Read More</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination-controls class="paginator-container" (pageChange)="p = $event"></pagination-controls>
    </div>
    <app-subscribe></app-subscribe>
    <app-footer></app-footer>
</div>